<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat class="card-border">
          <h2>Просмотр сбросов корзины</h2>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-card flat tile>
          <v-card-text>
            <v-toolbar flat>
              <v-menu offset-y bottom>
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="mx-3"
                    label="Выберите дату"
                    v-model="day"
                    v-on="on"
                    :disabled="inAction"
                    style="max-width: 220px"
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker
                  :allowed-dates="allowedDates"
                  :disabled="inAction"
                  locale="ru"
                  first-day-of-week="1"
                  v-model="day"
                  :landscape="true"
                  :reactive="true"
                ></v-date-picker>
              </v-menu>
              <v-btn
                color="primary"
                class="mx-5"
                :disabled="inAction || !day"
                @click="fetchCartDumps()"
              >Посмотреть</v-btn>
              <v-btn
                v-if="filtered.length > 0"
                outlined
                text
                color="primary"
                @click="saveAs()"
              >
                <v-icon>save</v-icon>
              </v-btn>
              <span v-if="filtered.length > 0" class="mx-4">Итого за день: <b>{{ totalCarts }}</b> сбросов (<b>{{ totalAmount }}</b> руб.)</span>
              <v-spacer></v-spacer>
              <v-text-field
                v-if="filtered.length > 0 || search.length > 0"
                v-model="search"
                name="search"
                label="Поиск по ФИО или столовой"
                class="search mx-3"
              ></v-text-field>
              <v-select
                v-if="search.length > 0 || filtered.length > 0"
                :items="sortingTypes"
                v-model="sortingType"
                label="Сортировка"
                dense
                class="sorting-select mx-2"
              ></v-select>
              <v-btn
                v-if="search.length > 0 || filtered.length > 0"
                text
                icon
                class="mx-2"
                color="primary"
                @click="reverseSorting()"
              >
                <v-icon>sort</v-icon>
              </v-btn>
            </v-toolbar>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <div style="text-align:center">
              <span v-if="filtered.length === 0">Нет данных</span>
            </div>
            <template>
              <v-treeview
                dense
                :items="filtered"
                item-key="personid"
              >
                <template v-slot:label="{ item }">
                  {{ item.name }}
                  <span v-if="item.price"> = <strong>{{ item.price }} руб</strong></span>
                  <span v-if="item.amount"> [{{ item.cafe }}] => (<strong>{{ item.amount }} руб</strong>)
                    {{ item.productCount ? ` Продуктов: ${item.productCount}` : item.cartCount ? `Количество сбросов: ${item.cartCount }` : '' }}
                  </span>
                </template>
              </v-treeview>
            </template>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
const moment = require('moment')
const FileSaver = require('file-saver')
const encoding = require('encoding')

function rubles (kops) {
  return (parseFloat(kops) / 100).toFixed(2)
}

export default {
  name: 'ViewMenu',
  data: () => ({
    day: null,
    inAction: false,
    progress: 0,
    menu: null,
    items: [],
    filtered: [],
    sortingType: null,
    sortingTypes: [
      { text: 'По ФИО', value: 'name' },
      { text: 'По столовой', value: 'cafe' },
      { text: 'По кол-ву сбросов', value: 'cartCount' },
      { text: 'По сумме за день', value: 'amount' }
    ],
    totalCarts: 0,
    totalAmount: 0,
    search: '',
    csv: '',
    csvfilename: ''
  }),
  methods: {
    allowedDates (val) {
      return moment().isAfter(val) || moment().isSame(val)
    },
    asyncTimeout (to) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, to)
      })
    },
    dateFormat (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss').toString()
    },
    async fetchCartDumps () {
      this.sortingType = null
      try {
        this.items = []
        const day = this.day
        if (!day) throw new Error('Выберите дату')
        this.progress = 1
        this.inAction = true
        await this.asyncTimeout(500)
        const { items } = await this.$store.dispatch('sioRequest', {
          topic: 'org-cartdumps',
          pl: { day }
        })
        items.forEach(x => {
          console.log(x)
          if (x !== null && x.cartdumps && x.cartdumps.length !== 0) {
            this.items.push({
              name: x.fullname,
              amount: rubles(x.cartdumps.reduce((a, b) => a + b.amount, 0)),
              cafe: x.cafe,
              cartCount: x.cartdumps.length,
              children: x.cartdumps.map(c => {
                return {
                  name: `${this.dateFormat(c.cts)}`,
                  amount: rubles(c.amount),
                  cafe: x.cafe,
                  productCount: c.cart.length,
                  children: c.cart.map(product => {
                    return {
                      name: `${product.title}`,
                      price: rubles(product.price)
                    }
                  })
                }
              })
            })
          }
        })
        this.filtered = this.items.sort((a, b) => parseInt(a.cafe.split(' ')[1]) > parseInt(b.cafe.split(' ')[1]) ? 1 : -1)
        this.totalAmount = rubles(this.items.reduce((a, b) => a + b.amount * 100, 0))
        this.totalCarts = this.items.reduce((a, b) => a + b.cartCount, 0)
      } catch (err) {
        console.log(err)
        this.$store.dispatch('snack', err)
      } finally {
        this.inAction = false
      }
    },
    reverseSorting () {
      this.filtered = this.filtered.reverse()
    },
    saveAs () {
      this.csvfilename = `cartdumps-${moment(this.day).format('YYYY-MM-DD')}.csv`
      this.csv = 'Столовая;Кассир;Сброс корзины;Продукты;Цены;Итого;\n'
      try {
        this.filtered.forEach(x => {
          this.csv += `${x.cafe};${x.name};Кол-во: ${x.cartCount};;;${x.amount.toString().replace('.', ',')};\n`
          x.children.forEach(cartdump => {
            this.csv += `;;${cartdump.name};;;;\n`
            cartdump.children.forEach(product => {
              this.csv += `;;;${product.name};${product.price.toString().replace('.', ',')};;\n`
            })
            this.csv += `;;;;;${cartdump.amount.toString().replace('.', ',')};\n\n`
          })
        })
        const file = new File(
          [encoding.convert(this.csv, 'cp1251')],
          this.csvfilename,
          { type: 'text/plain;charset=cp1251' }
        )
        FileSaver.saveAs(file)
      } catch (error) {
        this.$store.dispatch('snack', error)
      }
    }
  },
  watch: {
    day () {
      this.items = []
      this.filtered = []
      this.inAction = false
    },
    sortingType (val) {
      if (val) {
        switch (val) {
          case 'name': {
            this.filtered = this.filtered.sort((a, b) => a.name.localeCompare(b.name))
            break
          }
          case 'cafe': {
            this.filtered = this.filtered.sort((a, b) => parseInt(a.cafe.split(' ')[1]) > parseInt(b.cafe.split(' ')[1]) ? 1 : -1)
            break
          }
          case 'cartCount': {
            this.filtered = this.filtered.sort((a, b) => parseInt(a.cartCount) > parseInt(b.cartCount) ? 1 : -1)
            break
          }
          case 'amount': {
            this.filtered = this.filtered.sort((a, b) => parseFloat(a.amount) > parseFloat(b.amount) ? 1 : -1)
            break
          }
        }
      }
    },
    search (val) {
      if (val) {
        this.filtered = [...this.items.filter(x => x.name.toLowerCase().includes(val.toLowerCase())),
          ...this.items.filter(x => x.cafe.toLowerCase().includes(val.toLowerCase()))]
      } else {
        this.filtered = this.items
      }
    }
  },
}
</script>
<style lang="css">
.sorting-select {
  width: 150px;
  max-width: 200px;
}
.search {
  width: 300px;
  max-width: 300px;
}
</style>
